
import ForgetPassword from "../Pages/Authentication/ForgetPassword";
import Pin from "../Pages/Authentication/Pin";
import ResetPassword from "../Pages/Authentication/ResetPassword";
import ForcedChangePassword from "../Pages/Authentication/ForcedChangePassword";



export const authRoutes = [
 //Error
 { path: `/authentication/pin`, Component: <Pin />},
 { path: `/authentication/forgetpassword`, Component:<ForgetPassword />},
 { path: `/authentication/resetpassword`, Component: <ResetPassword />},
 { path: `/authentication/changepassword`, Component: <ForcedChangePassword />},

];